import numeral from 'numeral';
import PropTypes from 'prop-types';
import { aggregateActs } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import Conversion from 'bloko/blocks/conversion';
import Text from 'bloko/blocks/text';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import { ActType } from 'components/Admin/Reports/ActsReport/Labels';
import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

import { ActType as ActTypeEnum } from 'store/models/acts';
import { useSelector } from 'store/utils';

import 'components/Admin/Reports/ActsReport/Total/Total.less';

const Total = () => {
    const { acts, isLoad } = useSelector((state) => state.acts);
    const trl = useTrls();

    const HH_LABEL = <ActType type={ActTypeEnum.HH} />;
    const CLICKME_LABEL = <ActType type={ActTypeEnum.Clickme} />;

    if (acts.length === 0 || isLoad) {
        return null;
    }
    const amounts = aggregateActs(acts);
    return (
        <div className="acts-total">
            <Table className="acts-total-content">
                <TableBody>
                    <TableRow>
                        <TableCell className="acts-total-cell">
                            <Conversion
                                zero={trl('admin.actsReport.actsTable.total.acts.zero')}
                                one={trl('admin.actsReport.actsTable.total.acts.one')}
                                some={trl('admin.actsReport.actsTable.total.acts.some')}
                                many={trl('admin.actsReport.actsTable.total.acts.many')}
                                value={acts.length}
                                hasValue={false}
                            />
                        </TableCell>
                        <TableCell className="acts-total-cell">
                            <Text Element="span" strong>
                                {numeral(acts.length).format('0,0')}
                            </Text>
                            {NON_BREAKING_SPACE}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="acts-total-cell">{CLICKME_LABEL}</TableCell>
                        <TableCell className="acts-total-cell">
                            {numeral(amounts.counts.clickme).format('0,0')}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="acts-total-cell">{HH_LABEL}</TableCell>
                        <TableCell className="acts-total-cell">{numeral(amounts.counts.hh).format('0,0')}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <div className="acts-total-divider" />
            <Table className="acts-total-content">
                <TableBody>
                    <TableRow>
                        <TableCell className="acts-total-cell">
                            {trl('admin.actsReport.actsTable.total.amount')}
                        </TableCell>
                        <TableCell className="acts-total-cell">
                            <Text Element="span" strong>
                                {numeral(amounts.all).format('0,0')}
                            </Text>
                            {NON_BREAKING_SPACE}
                            {trl('balance.currency')}.
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="acts-total-cell">{CLICKME_LABEL}</TableCell>
                        <TableCell className="acts-total-cell">
                            <Text Element="span" strong>
                                {numeral(amounts.clickme).format('0,0')}
                            </Text>
                            {NON_BREAKING_SPACE}
                            {trl('balance.currency')}.
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className="acts-total-cell">{HH_LABEL}</TableCell>
                        <TableCell className="acts-total-cell">
                            <Text Element="span" strong>
                                {numeral(amounts.hh).format('0,0')}
                            </Text>
                            {NON_BREAKING_SPACE}
                            {trl('balance.currency')}.
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );
};

Total.propTypes = {
    isLoad: PropTypes.bool,
    acts: PropTypes.arrayOf(
        PropTypes.shape({
            amount: PropTypes.number,
            type: PropTypes.string,
        })
    ),
};

export default Total;
